import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie';

Vue.use(Vuex)

const store=new Vuex.Store({
  state: {
    app_id:'',
    user: {
      name: ''
    },
    app_code: '',
    app_code_center: '',
    app_id_center: ''
  },
  mutations: {
    changeapp (state,id){
      state.app_id = id
      console.log(id)
      console.log(state.app_id)
    },
    changeappCenter (state,id){
      state.app_id_center = id
      console.log(id)
      console.log(state.app_id_center)
    },
    saveuser (state,user){
      state.user.name = user.name
    },
    changeAppcode(state,code){
      state.app_code = code

    },
    changeAppcodeCenter(state,code){
      state.app_code_center = code

    },
    logout (state) {
      Cookies.remove('password');
      Cookies.remove('access');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('session');
      localStorage.removeItem('app_code');
      localStorage.removeItem('app_id_center');
      localStorage.removeItem('app_id');
    }
  },

})


export default store //导入Store



// WEBPACK FOOTER //
// ./src/store/index.js